import React, { Component } from 'react'
import { translate } from "react-i18next"
import { currencySymbol } from 'cogsworth/utils/currencies'

import './Select.css'

class InputSelectMulti extends Component {
  constructor(props){
    super(props)

    this.state = this.getState(this.props)

    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.moveDown = this.moveDown.bind(this)
    this.moveUp = this.moveUp.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentWillReceiveProps(nextProps){
    this.setState(this.getState(nextProps), () => {
      if(document.hasFocus()) {
        this.input.focus()
      }
    })
  }

  componentDidMount(){
    if(document.hasFocus()) {
      this.input.focus()
    }
  }

  getState(props){
    let state = {
      value: null,
      inputText: '',
      selectedIndex: -1,
      highlighted: null,
      selectedOptions: [],
    }


    if (props.value === null || props.value === undefined || props.value === '') {
      return state
    }


    const values = props.value.split(';')
    let selectedOptions = props.options.filter(o => values.some(v => v === o.id))


    if (selectedOptions.length === 0) {
      state.value = props.value
      state.selectedIndex = 0
    }

    return {
      value: props.value,
      selectedIndex: props.options.findIndex(o => selectedOptions.some(s => s.id === o.id)),
      selectedOptions,
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if(document.hasFocus()) {
      this.input.focus()
    }
  }

  handleSubmit(){
    const { selectedOptions } = this.state

    if (selectedOptions.length === 0 && this.props.required) {
      // Must select an option
      this.setState({ error: true })
      setTimeout(() => { this.setState({ error: false }) }, 500)
      return null
    }

    if (this.props.onSubmit) {
      // Add a small delay before submitting for user visual feedback
      setTimeout(() => {
        this.props.onSubmit(this.state.value)
      }, 250)
    }
  }

  handleInputChange(e){
    const selectedIndex = this.props.options.findIndex(o => o.name.toUpperCase().indexOf(e.target.value.toUpperCase()) > -1)
    const highlighted = this.props.options.filter(o => o.name.toUpperCase().indexOf(e.target.value.toUpperCase()) > -1)
    if (highlighted.length >= 0) {
      this.setState({
        selectedIndex,
        highlighted
      })
    }
  }

  handleClick(index, option){
    const existingIndex = this.state.selectedOptions.findIndex(o => o.id === option.id)
    const selectedOptions = existingIndex === -1 ? [...this.state.selectedOptions, option] : this.state.selectedOptions.filter(o => o.id !== option.id)

    this.setState({
      selectedIndex: index,
      selectedOptions,
      value: this.valueFor(selectedOptions),
    })
  }

  toggleHighlighted() {
    const option = this.props.options[this.state.selectedIndex]
    this.handleClick(this.state.selectedIndex, option)
  }

  handleKeyDown(e, input){
    if (e.keyCode === 13) { // Enter
      e.preventDefault()
      this.toggleHighlighted()
    } else if ( e.keyCode === 38 ) { // Top arrow
      this.moveUp()
    } else if ( e.keyCode === 40 ) { // Bottom arrow
      this.moveDown()
    }
  }

  moveUp() {
    const selectedIndex = this.state.selectedIndex > 0 ? this.state.selectedIndex - 1 : this.props.options.length - 1
    this.setState({ selectedIndex })
  }

  moveDown() {
    const selectedIndex = this.state.selectedIndex < (this.props.options.length - 1) ? this.state.selectedIndex + 1 : 0
    this.setState({ selectedIndex })
  }

  labelFor(option) {
    if(option.durations && option.durations.length === 1 && option.durations[0].price > 0) {
      return <span>{option.name} - {currencySymbol(option.currency)} {option.durations[0].price}</span>
    }

    return option.name
  }


  mainInputValueFor(options) {
    if (options.length === 0) {
      return ''
    }

    return options.map(o => o.name).join(', ')
  }

  valueFor(options) {
    if (options.length === 0) {
      return ''
    }

    return options.map(o => o.id).join(';')
  }

  renderCheckbox(option) {
    const isChecked = this.state.selectedOptions.find(o => o.id === option.id)

    return (
      <div className="checkbox">
        { isChecked && <div className="check"></div> }
      </div>
    )
  }

  render() {
    let { id, options, color } = this.props
    const { selectedIndex, highlighted } = this.state

    if(!options)
      options = []

    return (
      <div className="booking-input booking-input-select inside-button">
        <div className={`booking-input-wrapper ${ this.state.error ? 'shake' : '' }`}>
          <input ref={input => this.input = input} type="text" id={id} name={id} onChange={this.handleInputChange} onKeyDown={(e) => { this.handleKeyDown(e, 'mainInput') }} value={this.mainInputValueFor(this.state.selectedOptions)} />
          <button onClick={this.handleSubmit} style={{ backgroundColor: color }}>{this.props.okButtonLabel}</button>
        </div>
        <ul className="options">
          {
            options.map((option, i) => {
              const hidden = ( highlighted && highlighted.length > 0 && !highlighted.find(i => i.id === option.id) && !(option.id === 'any') ) ? 'hidden' : ''
              const selected = selectedIndex === i ? 'selected' : ''
              return (
                <li key={option.id} className={`${selected} ${hidden}`} onClick={() => { this.handleClick(i, option) }}>
                  { this.labelFor(option) }&nbsp;
                  { option.description && <small>{ option.description }</small>}
                  { this.renderCheckbox(option) }
                </li>
              )
            })
          }
        </ul>
      </div>
    );
  }
}

export default translate("translations")(InputSelectMulti)
